export class LLMError extends Error {
  constructor(public message: string, public code: string) {
    super(message);
    this.name = 'LLMError';
  }
}


export interface LLMCopyResult {
  success: boolean;
  bytesCopied: number;
  filename: string;
  message: string;
}
